<template>
  <div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <div class="row">
            <!-- Items per page -->
            <div class="col-sm-12 col-md-6">
              <b-form-group label="Data filtragem" class="mt-3">
                <date-range-picker
                  id="range"
                  ref="picker"
                  v-model="date"
                  opens="right"
                  class="periodo"
                  :locale-data="localeDate"
                  :show-week-numbers="false"
                  :show-dropdowns="true"
                  :auto-apply="false"
                  :ranges="dateRanges"
                >
                  <template
                    v-if="date.startDate && date.endDate"
                    v-slot:input="picker"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </template>
                  <template v-else v-slot:input> Período </template>
                </date-range-picker>
              </b-form-group>

              <div class="mb-3">
                <b-dropdown
                  id="dropdown-left"
                  :text="
                    sortDate == 'date_updated'
                      ? 'Data de atualização'
                      : 'Data de criação'
                  "
                  variant="light"
                  class="mt-2"
                >
                  <b-dropdown-item
                    href="#"
                    @click.prevent="dateSort('date_updated')"
                    >Data de atualização</b-dropdown-item
                  >
                  <b-dropdown-item
                    href="#"
                    @click.prevent="dateSort('date_created')"
                    >Data de criação</b-dropdown-item
                  >
                </b-dropdown>
                <b-button
                  variant="dark"
                  class="ml-2 mt-2"
                  @click.prevent="fetchSubscriptions"
                  >Recarregar lista</b-button
                >
              </div>
            </div>
            <!-- End Items per page -->
          </div>

          <!-- Table -->
          <div class="row">
            <div class="col-12">
              <div
                v-if="subscriptions && subscriptions.length && !loading"
                class="table-responsive mb-0"
              >
                <b-table
                  :items="subscriptions"
                  :fields="fields"
                  responsive="sm"
                >
                  <template v-slot:cell(status)="data">
                    <div>
                      <b class="mr-1">Motivo:</b>
                      <span>{{ data.item.reason }}</span>
                    </div>
                    <div
                      ><b class="mr-1">Pagarme:</b>

                      <span
                        v-if="data.item.remote"
                        :class="{
                          'is-green': data.item.remote.status == 'paid',
                          'is-light-blue':
                            data.item.remote.status == 'processing' ||
                            data.item.remote.status == 'waiting_payment' ||
                            data.item.remote.status == 'unpaid' ||
                            data.item.remote.status == 'trialing',
                          'is-red':
                            data.item.remote.status == 'reject' ||
                            data.item.remote.status == 'refused' ||
                            data.item.remote.status == 'canceled',
                          'is-black':
                            data.item.remote.status == 'refunded' ||
                            data.item.remote.status == 'delayed',
                          'is-warning':
                            data.item.remote.status == 'pending_approbation',
                        }"
                        >{{ data.item.remote.status }}
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div
                      ><b class="mr-1">Greenn:</b>
                      <span
                        v-if="data.item.local"
                        :class="{
                          'is-green': data.item.local.status == 'paid',
                          'is-light-blue':
                            data.item.local.status == 'processing' ||
                            data.item.local.status == 'waiting_payment' ||
                            data.item.local.status == 'unpaid' ||
                            data.item.local.status == 'trialing',
                          'is-red':
                            data.item.local.status == 'reject' ||
                            data.item.local.status == 'refused' ||
                            data.item.local.status == 'canceled',
                          'is-black':
                            data.item.local.status == 'refunded' ||
                            data.item.local.status == 'delayed',
                          'is-warning':
                            data.item.local.status == 'pending_approbation',
                        }"
                      >
                        {{ data.item.local.status }}
                      </span>
                      <span v-else>-</span>
                    </div>
                  </template>
                  <template v-slot:cell(seller)="data">
                    <div class="externclass">
                      <div
                        class="classification"
                        :style="setColor(data.item.classification)"
                      ></div>
                      <p>{{
                      data.item.local
                        ? data.item.local.seller.name
                        : 'Sem dados do vendedor'
                    }}</p>
                    </div>
                    <b>{{
                      data.item.local ? data.item.local.seller.cpf_cnpj : ''
                    }}</b>
                    <div v-if="data.item.local">
                      <a
                        v-if="data.item.local.seller.cellphone"
                        :href="`https://api.whatsapp.com/send?phone=+55${data.item.local.seller.cellphone.replace(
                          /[() -]/g,
                          ''
                        )}`"
                        target="_blank"
                        ><i class="fab fa-whatsapp"></i>
                        {{ data.item.local.seller.cellphone }}</a
                      ></div
                    >
                    <div>{{
                      data.item.local ? data.item.local.seller.email : ''
                    }}</div>
                  </template>

                  <template v-slot:cell(client)="data">
                    <div>{{
                      data.item.local
                        ? data.item.local.client.name
                        : data.item.remote.customer.email
                    }}</div>
                    <b v-if="data.item.local">{{
                      data.item.local.client.cpf_cnpj
                    }}</b>
                    <div v-if="data.item.local">
                      <a
                        v-if="data.item.local.client.cellphone"
                        :href="`https://api.whatsapp.com/send?phone=+55${data.item.local.client.cellphone.replace(
                          /[() -]/g,
                          ''
                        )}`"
                        target="_blank"
                        ><i class="fab fa-whatsapp"></i>
                        {{
                          data.item.local
                            ? data.item.local.client.cellphone
                            : 'sem dados'
                        }}</a
                      ></div
                    >
                  </template>

                  <template v-slot:cell(product)="data">
                    <div v-if="data.item.local">
                      {{ data.item.local.product.name }}
                    </div>
                    <div v-else>
                      <a :href="data.item.remote.manage_url" target="_blank"
                        >Gerenciar Assinatura</a
                      >
                    </div>
                    <b v-if="data.item.local">{{
                      data.item.local.product.type == 'TRANSACTION'
                        ? 'TRANSAÇÃO'
                        : 'ASSINATURA'
                    }}</b>
                    <b v-else>{{
                      data.item.remote.object == 'transaction'
                        ? 'TRANSAÇÃO'
                        : 'ASSINATURA'
                    }}</b>
                    <div v-if="data.item.local">
                      R$ {{ formatMoney(data.item.local.product.amount) }}
                    </div>
                    <div v-else
                      >R$
                      {{
                        formatMoney(insertDot(data.item.remote.plan.amount, -2))
                      }}</div
                    >
                  </template>

                  <template v-slot:cell(created_at)="data">
                    {{ data.item.remote.date_created | datetime }}
                  </template>

                  <template v-slot:cell(_actions)="data" class="d-flex">
                    <b-button
                      variant="success"
                      class="mb-1 mr-1"
                      @click="openJson(data.item)"
                    >
                      <!-- <i class="fas fa-code"></i> -->
                      Ver JSON
                    </b-button>
                    <!-- <b-button
                      variant="dark"
                      class="mb-1"
                      @click="
                        openwebhook(
                          data.item.local
                            ? data.item.local.subscription_id
                            : data.item.remote.id
                        )
                      "
                    >
                       <i class="fas fa-share-alt"></i> -->
                     <!-- Webhook
                    </b-button> -->
                    <b-button
                      variant="danger"
                      class="ml-1 mb-1"
                      @click="deleteReconcile(data.item.id, data.index)"
                    >
                      <!-- <i class="fas fa-share-alt"></i> -->
                      Deletar
                    </b-button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>

          <div v-if="loading" class="row justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div
            v-if="subscriptions && subscriptions.length == 0 && !loading"
            class="row justify-content-center"
          >
            <div class="alert alert-dark" role="alert">
              Nenhum dado encontrato.
            </div>
          </div>
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col -->
    </div>
    <ModalJson :data-json="dataJson" />
    <ModalWebhook :data-webhook="dataWebhook" :type="type" />
  </div>
</template>


<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Money from '@src/mixins/money'
import ModalJson from './modal-json'
import ModalWebhook from './modal-webhook.vue'
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import ReconcileSubscriptionService from '@services/resources/ReconcileSubscriptionService'
import ReconcileService from '@services/resources/ReconcileService'
import Vue from 'vue'
const serviceReconcileSubscriptions = ReconcileSubscriptionService.build()
const serviceReconcile = ReconcileService.build()

export default {
  page: {
    title: 'Conciliação Assinaturas',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ModalJson,
    ModalWebhook,
    DateRangePicker,
  },
  mixins: [Money],
  data() {
    return {
      title: 'Conciliação Assinaturas',
      type: 'subscription',
      loading: true,
      items: [
        {
          text: 'Início',
          href: '/',
        },
        {
          text: 'Conciliação Assinaturas',
          active: true,
        },
      ],
      fields: [
        // { key: 'reason', label: 'Motivo', sortable: false },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'seller', label: 'Vendedor', sortable: false },
        { key: 'client', label: 'Cliente', sortable: false },
        { key: 'product', label: 'Produto', sortable: false },
        { key: 'created_at', label: 'Data transação', sortable: false },
        { key: '_actions', label: 'Ações', sortable: false },
      ],
      subscriptions: [],
      dataJson: {},
      dataWebhook: 0,
      date: {
        startDate: moment().format('YYYY-MM-DDT00:00:00'),
        // endDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
        endDate: moment().format(),
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
      sortDate: 'date_updated',
    }
  },
  computed: {
    dateRanges() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), 30),
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      }
    },
  },
  watch: {
    date(value) {
      this.loading = true
      let start = value.startDate
      let end = value.endDate
      this.date.startDate = moment(start).format()
      this.date.endDate = moment(end).format()
      this.fetchSubscriptions()
    },
  },
  mounted() {
    this.fetchSubscriptions()
  },
  methods: {
    setColor(type) {
      if (type) {
        if (type === 'green') {
          return 'background: #00E4A0'
        }
        if (type === 'yellow') {
          return 'background: #fff700'
        }
        if (type === 'red') {
          return 'background: #FF0A44'
        }
        if (type === 'black') {
          return 'background: #000000'
        }
      }else{
          return 'background:#c7c7c7;';
      }
    },
    dateSort(sort) {
      if (this.sortDate != sort) {
        this.sortDate = sort
        this.fetchSubscriptions()
      }
    },
    insertDot(a, pos) {
      a = a.toString()

      if (a) {
        a = parseFloat(
          a.substring(0, a.length + pos) +
            '.' +
            a.substring(a.length + pos, a.length)
        )
      }

      return a
    },
    deleteReconcile(id, index) {
      Vue.swal({
        title: 'Deletar Conciliação',
        text: 'Tem certeza que deseja deletar este item?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Deletar',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-danger mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true
          let data = {
            id,
          }
          serviceReconcile
            .destroy(data)
            .then((response) => {
              console.log(response)
              this.transactions.splice(index, 1)
              this.$bvToast.toast('Item deletado com sucesso', {
                title: 'Conciliação',
                variant: 'success',
                autoHideDelay: 5000,
                appendToast: true,
              })
            })
            .catch((error) => {
              console.log(error)
              this.$bvToast.toast('Houve um erro ao deletar o item', {
                title: 'Conciliação',
                variant: 'danger',
                autoHideDelay: 5000,
                appendToast: true,
              })
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    openJson(json) {
      this.dataJson = json
      this.$bvModal.show('json-viewer')
    },
    openwebhook(webhook) {
      this.dataWebhook = webhook
      this.$bvModal.show('webhook-viewer')
    },
    fetchSubscriptions() {
      this.loading = true
      let data = {
        startDate: this.date.startDate,
        endDate: this.date.endDate,
        dateToFilter: this.sortDate,
      }
      // axios
      //   .get(
      //     `https://apiadm.greenn.com.br/reconcile/pagarme/subscription/?startDate=${data.startDate}&endDate=${data.endDate}&dateToFilter=${data.dateToFilter}`
      //   )
      serviceReconcileSubscriptions
        .search(data)
        .then((r) => {
          this.subscriptions = r
          this.loading = false
        })
        .catch((error) => {
          console.log(error)
          this.subscriptions = []
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.periodo {
  width: 200px;
}
.is-green {
  color: #00e4a0;
  font-weight: 600;
}

.is-red {
  color: #ff0c37;
  font-weight: 600;
}

.is-warning {
  color: #ffcb37;
  font-weight: 600;
}

.is-light-blue {
  color: #2133d2;
  font-weight: 600;
}

.is-black {
  color: rgb(14, 0, 41);
  font-weight: 600;
}
</style>
